import React from "react";
import PropTypes from "prop-types";
import { Card, Row, Col, Modal, Result, Button, Alert } from "antd";
import CompanyCreateForm from "./forms/add-company-form";
import CompanyService from "services/company-service";
import { GSTIN_REGEX } from "constants/regex";
import {
    createCompanyLosProfile
} from "./actions";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import {
    CompanyProfileRecord,
    SpocUserRecord
} from "./records";


class CompanyProfileCreate extends React.Component {
    state = {
        submitting: false,
        stage: "EDITING",
    }
    formRef = React.createRef();

    fetchIndustryTypes = async search => {
        return CompanyService.industryTypeList(search);
    }
    fetchGstin = gstin => {
        return CompanyService.parseGSTIN(gstin).then(({ data }) => data).catch(() => []);
    }
    fetchChannelProducts = search => {
        return CompanyService.getChannelProducts(search);
    }
    fetchSalesManagers = async (search) => {
        return CompanyService.getDRMList(search);
    }
    fetchVpSalesManagers = async search => {
        return CompanyService.getVPSMList(search);
    }
    fetchCreatedCompanies = async gstin => {
        const { data } = await CompanyService.getCompanyProfiles(null, gstin);
        return data;
    }
    showExistingCompanyModal(companies) {
        Modal.error({
            title: "Company with GSTIN already exist",
            content: (
                <div>
                    {companies.map(_ => _)}
                </div>
            ),
            onOk: () => {
                this.formRef.current.resetFields();
            }
        });
    }
    gstinValidation = {
        validator: async (rule, value, callback) => {
            if (value.length === 15 && !GSTIN_REGEX.test(value) || value.length !== 15 && value.length>0) {
                return callback("Invalid GSTIN");
            }
            // if (value && this.gstin && this.gstin.gstin === value) {
            //     callback();
            // }
            if (value && value.length > 0 && GSTIN_REGEX.test(value)) {
                const companies = await this.fetchCreatedCompanies(value);
                if (companies.length > 0) {
                    this.showExistingCompanyModal(companies, callback());
                }
                const gstinBlob = await this.fetchGstin(value);

                if (gstinBlob && gstinBlob.gstin === value) {
                    this.gstin = gstinBlob;
                    const companyName = this.formRef.current.getFieldValue("name");

                    if (!companyName || companyName.length === 0) {
                        this.formRef.current.setFieldsValue({
                            name: this.gstin.tradeNam
                        });
                        callback();
                    } else {
                        this.confirmCompanyName(companyName, callback);
                    }

                } else {
                    callback("Invalid Gstin");
                }
            }
        }
    }
    async confirmCompanyName(name, callback) {
        if (name !== this.gstin.tradeNam) {
            callback("Name Mismatch");
        }
    }
    onValuesSubmit = (companyValues) => {
        this.props.createCompanyLosProfile(companyValues);
        this.setState({
            submitting: true
        });
    }
    renderEditingScreen() {
        return (<CompanyCreateForm
            ref={this.formRef}
            companyValues={new CompanyProfileRecord(this.props.profile)}
            spocValues={
                this.props.profile &&
                this.props.profile.associates &&
                this.props.profile.associates.filter(_ => _.type === 1).map(_ => new SpocUserRecord(_))
            }
            gstinValidator={this.gstinValidation}
            fetchChannelProducts={this.fetchChannelProducts}
            onValuesSubmit={this.onValuesSubmit}
            loading={this.props.profileCreateStatus && this.props.profileCreateStatus === "CREATING"}
            fetchSalesManagers={this.fetchSalesManagers}
            fetchIndustryTypes={this.fetchIndustryTypes}
            fetchVpSalesManagers={this.fetchVpSalesManagers}
        />);
    }

    addAnotherCompany = () => {
        this.formRef.current.resetFields();
    }
    proceedToCompanyDetails = () => {

    }

    renderSuccessResult() {
        return (
            <Result
                status="success"
                title="Successfully Created Company"
                description="Company Name"
                extra={[
                    <Button type={"primary"} key="details" onClick={this.proceedToCompanyDetails}>
                        Go to Details
                    </Button>,
                    <Button key={"new-company"} onClick={this.addAnotherCompany}>
                        Add Another
                    </Button>
                ]}
            />
        );
    }

    renderFailedResult() {
        return (
            <Alert message="Company Creation Failed" type="error" className={"mb-10"} />
        );
    }

    renderStage = () => {
        const { stage } = this.state;
        /*eslint-disable*/
        switch (stage) {
            case "EDITING":
                return this.renderEditingScreen();
            case "SUCCESS":
                return this.renderSuccessResult();
            case "FAILED":
                return (<React.Fragment>
                    {this.renderFailedResult()}
                    {this.renderEditingScreen()}
                </React.Fragment>);
            default:
                return null;
        }
    }

    render() {
        return (
            <Row className={"p-10"}>
                <Col span={16} offset={4}>
                    <Card title={"Create Company"}>
                        {this.renderStage()}
                    </Card>
                </Col>
            </Row>
        );
    }
}

CompanyProfileCreate.propTypes = {
    history: PropTypes.object,
    match: PropTypes.object,
    location: PropTypes.object,
    createCompanyLosProfile: PropTypes.func,
    profile: PropTypes.object,
    profileCreateStatus: PropTypes.string
};

const mapStateToProps = (state) => ({
    profileCreateStatus: state.companyLosProfiles.getIn(["createProfile", "status"])
});

const mapDispatchToProps = dispatch =>
    bindActionCreators(
        {
            createCompanyLosProfile
        },
        dispatch
    )

export default connect(mapStateToProps, mapDispatchToProps)(CompanyProfileCreate);
